import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { SOCKET_BASE_URL } from '../../constants/CONSTANT';

const ChatBotFlowList = ({ selectedWhatsAppSetting }) => {
  const [iframeLoading, setIframeLoading] = useState(true);
  const watconnectToken = localStorage.getItem('watconnect_token') || '';

  // Reset loading state when the selected business number changes
  useEffect(() => {
    setIframeLoading(true);
  }, [selectedWhatsAppSetting]);

  if (!selectedWhatsAppSetting) {
    return (
      <Container className='mt-5'>
        <Row className='justify-content-center'>
          <Col md={8}>
            <Card className='text-center p-5 shadow-lg border-0 rounded-3 bg-white'>
              <Card.Body>
                <div
                  className='mb-4'
                  style={{
                    fontSize: '4.5rem',
                    filter: 'drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.08))',
                  }}
                >
                  🤖
                </div>
                <Card.Title
                  className='fw-bold mb-3 fs-3'
                  style={{ color: '#2c3e50', letterSpacing: '-0.5px' }}
                >
                  Select a WhatsApp Number
                </Card.Title>
                <Card.Text
                  className='text-muted mx-auto'
                  style={{
                    fontSize: '1.05rem',
                    maxWidth: '480px',
                    lineHeight: '1.6',
                  }}
                >
                  Please select an active WhatsApp Business Number from the top
                  menu to load the Chatbot Flow Builder interface.
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }

  // Construct the dynamic iframe URL with target parameters
  const iframeUrl = `${SOCKET_BASE_URL}/chatbotflow?business_number=${encodeURIComponent(
    selectedWhatsAppSetting
  )}&token=${encodeURIComponent(watconnectToken)}`;

  return (
    <Container
      fluid
      className='px-4 py-4'
      style={{ minHeight: 'calc(100vh - 80px)', backgroundColor: '#f8f9fa' }}
    >
      <Row className='mb-4'>
        <Col>
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <h4
                className='fw-bold text-dark mb-1'
                style={{ letterSpacing: '-0.5px' }}
              >
                🤖 Chatbot Flow Builder
              </h4>
              <p className='text-muted mb-0 small'>
                Design and manage automated conversation flows for{' '}
                <span className='badge bg-primary-subtle text-primary fw-semibold px-2.5 py-1.5 fs-7'>
                  {selectedWhatsAppSetting}
                </span>
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={12}>
          <Card
            className='shadow-sm border-0 rounded-3 overflow-hidden bg-white'
            style={{ position: 'relative' }}
          >
            {iframeLoading && (
              <div
                className='d-flex flex-column justify-content-center align-items-center bg-white'
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  zIndex: 10,
                  minHeight: '680px',
                  transition: 'opacity 0.3s ease',
                }}
              >
                <Spinner
                  animation='border'
                  variant='primary'
                  className='mb-3'
                  style={{ width: '3rem', height: '3rem' }}
                />
                <span className='text-muted fw-semibold'>
                  Loading Chatbot Flow Builder...
                </span>
              </div>
            )}
            <iframe
              src={iframeUrl}
              title='Chatbot Flow Builder'
              onLoad={() => setIframeLoading(false)}
              style={{
                width: '100%',
                height: 'calc(100vh - 200px)',
                minHeight: '680px',
                border: 'none',
                display: 'block',
              }}
              allow='clipboard-read; clipboard-write; geolocation; microphone; camera'
            />
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ChatBotFlowList;
